<template>
    <path d="M4.89 15.55c0-2.46-.01-4.47-.03-4.47-.01 0-.25.17-.52.38l-.5.37-.77-.97c-.7-.91-.75-.98-.7-1.04.07-.06 9.5-7.11 9.6-7.17.02-.01.77.52 1.86 1.34l1.82 1.37V2.89h2.5l.01 2.17.01 2.17 1.72 1.3 1.75 1.32c.02.03-.2.35-.72 1.01l-.76.98-.5-.38-.53-.38c-.02 0-.03 2.01-.03 4.47v4.47H4.9zm4.58.51v-2.6h5.05v5.2h1.6l1.6-.02V10.2l-2.84-2.13a93.1 93.1 0 0 0-2.9-2.12 170 170 0 0 0-2.86 2.12l-2.83 2.1v8.5h3.18z"/>
</template>

<script>
    export default {
        name: 'office',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Office.vue